import React, { useRef } from 'react';
import { P5CanvasInstance, ReactP5Wrapper } from '@p5-wrapper/react';

export const RandomNumberProbability: React.FC = (props) => {
    const total = 20;
    const randomCounts = new Array(total).fill(0);
    const maxHeight = 100;

    const p5ref = useRef<P5CanvasInstance>();
    function sketch(p5: P5CanvasInstance) {
        p5ref.current = p5;
        let flag = false;

        p5.setup = () => {
            p5.createCanvas(640, 150);
            flag = false;
        }

        p5.draw = () => {
            p5.background(240);
            let index = p5.floor(p5.random(randomCounts.length));
            if (randomCounts[index] >= maxHeight) flag = true;
            if (!flag) randomCounts[index]++;

            p5.stroke(0);
            p5.strokeWeight(2);
            if (flag) {
                p5.fill(0, 200, 0);
            } else {
                p5.fill(127);
            }

            let w = p5.width / randomCounts.length;
            for (let x = 0; x < randomCounts.length; x++) {
                p5.rect(x * w, p5.height - randomCounts[x], w - 1, randomCounts[x]);
            }

            if (flag) p5.noLoop();
        };
    }

    return <ReactP5Wrapper sketch={sketch} />;
};

export default RandomNumberProbability;